<template>
  <div
    :class="['layout', _isMobile() ? 'mobile' : '']"
    :style="{
      'background-image': 'url(' + tenantConfig.json_homeBg.image + ')',
      'background-repeat': tenantConfig.json_homeBg.repeat,
      'background-color': tenantConfig.json_homeBg.color,
      'background-size': tenantConfig.json_homeBg.size,
    }"
  >
    <Header2 v-if="tenantConfig.headerType == 2" id="header"/>
    <Header3 v-else-if="tenantConfig.headerType == 3" id="header"/>
    <Header v-else id="header"/>
    <Banner/>
    <div class="home">
      <router-view />
    </div>
    <Footer/>
  </div>
</template>

<script>
import { mixinDevice } from "@/utils/mixin.js";
import Header from "@/components/header/Header";
import Header2 from "@/components/header/Header2";
import Header3 from "@/components/header/Header3";
import Banner from '@/components/header/Banner'
import Footer from "@/components/footer/Footer";
export default {
  name: "HomeLayout",
  mixins: [mixinDevice],
  components: {
    Header,
    Header2,
    Header3,
    Banner,
    Footer,
  },
  data() {
    return {
      tenantConfig: {}
    };
  },
  created() {
    this.tenantConfig = this.$store.getters.tenantInfo;
    console.log(this.tenantConfig);
    
  },
};
</script>
<style>
a * {
  transition: all 0.1s ease;
}
</style>
<style lang="less" scoped>
.layout {
  min-height: 100vh;
  // display: flex;
  // flex-direction: column;
  .banner-wrap {
    padding: 80px 0;
    background: #24a6e9;
    .banner-bg {
      position: absolute;
      width: 100%;
    }
    .banner {
      margin: auto;
      overflow: hidden;
      border-radius: 28px;
      box-shadow: 0px 6px 10px #0303031f;
    }
  }
  .home {
    margin: 0px auto;
    .pageLeft {
      width: 180px;
      height: calc(100vh - 75px);
      background: #fff;
    }
  }
  /deep/.ant-list-pagination {
    text-align: center;
  }
}
</style>